import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import { adminClient, phoneNumberClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import {
  ac as acPermission,
  admin as adminPermission,
  admin_staff as adminStaffPermission,
  user as userPermission,
} from "@/lib/permissions";

export const authClient = createAuthClient({
  plugins: [
    oauthProviderClient(),
    phoneNumberClient(),
    adminClient({
      ac: acPermission,
      roles: {
        admin: adminPermission,
        admin_staff: adminStaffPermission,
        user: userPermission,
      },
    }),
  ],
});
